import React, { useState, useEffect } from 'react';

import ShowAlarm from './ShowAlarm';
import ShowFault from './ShowFault';

const goToTrainPage = (CommonService, $state, train) => {
  const setSelectedTrain = CommonService.setSelectedTrain;
  $state.go('train', { consist: train.status.trainId });
};

const TrainInfo = ({ props, train }) => {
  const { alarm = '', fault = '' } = train.status && train.status.notifications || {};
  return (
    <div className="new-fleet-info__train__header">
      <button onClick={() => goToTrainPage(props.CommonService, props.$state, train)} className="new-fleet-info__train__header__title">
        <i className="fa fa-train vale-fleet-info__train__header__title--icon"></i>
        <span className="new-fleet-info__train__header__title--text">Train No. {train.trainId}</span>
      </button>
      <div className="new-fleet-info__train__header__events">
        <ShowAlarm alarm={alarm} />
        <ShowFault fault={fault} />
      </div>
    </div>
  )
};

export default TrainInfo